import { render, staticRenderFns } from "./ModalAcknowledge.vue?vue&type=template&id=16dd4378&scoped=true"
import script from "./ModalAcknowledge.vue?vue&type=script&lang=js"
export * from "./ModalAcknowledge.vue?vue&type=script&lang=js"
import style0 from "./ModalAcknowledge.vue?vue&type=style&index=0&id=16dd4378&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16dd4378",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16dd4378')) {
      api.createRecord('16dd4378', component.options)
    } else {
      api.reload('16dd4378', component.options)
    }
    module.hot.accept("./ModalAcknowledge.vue?vue&type=template&id=16dd4378&scoped=true", function () {
      api.rerender('16dd4378', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/ModalAcknowledge.vue"
export default component.exports